export const getRoleBadgeStyle = (role) => {
    switch (role) {
        case 'admin': return { bg: '#dbeafe', color: '#1e40af' };
        case 'doctor': return { bg: '#d1fae5', color: '#065f46' };
        case 'consultant': return { bg: '#e0e7ff', color: '#3730a3' };
        case 'receptionist': return { bg: '#fef3c7', color: '#92400e' };
        default: return { bg: '#f1f5f9', color: '#475569' };
    }
};
